module.exports = __webpack_public_path__ + "static/media/centralizedtimesheets.0b2bcc1f.webp";